import ButtonTwo from "../../buttonTwo";
import NameSection from "../../nameSection";

import {
  Banner,
  Container,
  ContainerButton,
  Content,
  Date,
  DateEdition,
  Logo,
  Month,
  NextEventOne,
} from "./styles";

import ImageComandatuba from "../../../assets/comandatuba/logo.svg";
import BannerImage from "../../../assets/comandatuba/banner.png";

const NextEvent = () => {
  return (
    <Container>
      <Content>
        <NextEventOne>
          <NameSection
            textOne="PRÓXIMO"
            textTwo="EVENTO"
            className="next_event"
          />
          <Banner src={BannerImage} />
          <Logo src={ImageComandatuba} alt="logo" />

          <DateEdition>
            <Month>JULHO</Month>
            <Date>
              <span>20</span> à <span>27</span>
            </Date>
          </DateEdition>

          <ContainerButton>
            <ButtonTwo
              icon={true}
              width="100%"
              onClick={() =>
                document
                  .getElementById("registration")
                  .scrollIntoView({ behavior: "smooth" })
              }
            >
              INSCREVA-SE
            </ButtonTwo>
          </ContainerButton>
        </NextEventOne>
      </Content>
    </Container>
  );
};

export default NextEvent;
